
import Axios from 'axios';
import classnames from 'classnames';
import sha256 from 'js-sha256';
import React, { useEffect, useState } from 'react';
import 'react-perfect-scrollbar/dist/css/styles.css';
import { toast } from 'react-toastify';
import { Button, Col, Modal, ModalBody, ModalFooter, ModalHeader, Nav, NavItem, NavLink, TabContent, TabPane } from 'reactstrap';
import { goRiceUrl } from '../../../../constant/siteConstants';
import getConfigToken from '../../../../utils/getConfigToken';
import useFormatMessage from '../../../../utils/useFormatMessage';
import PermissionTab from '../common/PermissionTab';
import MarkaRoleYonetimi from '../MarkaRolYonetimi/MarkaRoleYonetimi';
import Taseron from '../TaseronGrupYonetimi/Taseron';
import InformationForm from './InformationForm';
export default function EmployeeUpdateModal({ employeeId, employeeDetail, modalUpdate, setModalUpdate, trigger, setTrigger }) {
    /* eslint-disable  */
    // TODO : Remove eslint disable
    const { t } = useFormatMessage();
    const notifySuccess = (message) => toast.success(`${message}`);
    const notifyError = (message) => toast.error(`${message}`);
    const notify = (message) => toast.error(`${message}`);
    const [currentActiveTab, setCurrentActiveTab] = useState('1');

    const [roleGroups, setRoleGroups] = useState([]);
    const [selectedRowKeys, setSelectedRowKeys] = useState([])
    const [permissionGroupDatas, setPermissionGroupDatas] = useState([]);

    const [selectedPermissionGroup, setSelectedPermissionGroup] = useState();

    const [emailChange, setEmailChange] = useState(false)
    const [controlModal, setControlModal] = useState(false)
    const [selectedRow, setSelectedRow] = useState({
        EmployeeId: 0,
        Email: "",
        FullName: "",
        Unvan: "",
        UnvanKodu: "",
        SicilNo: "",
        OrgKodu: "",
        DepKodu: "",
        MasKodu: "",
        CalismaProgrami: "",
        UserName: "",
        Cinsiyet: "",
        Organization: "",
        Departman: "",
        MasrafYeri: "",
        Factories: [],
        IsActive: false,
        Password: "",
        FinishFactoryGroup: 0,
        RedirectPath: "",
        EmployeeNumber: ""
    })

    async function getRoleGroups() {
        await Axios.post(`${goRiceUrl}/api/employee/getAllRolesAndRoleGroup`, {}, getConfigToken).then((resp) => {
            resp.data.forEach(obj => {

                obj.checked = false

            })
            setRoleGroups(resp.data);
        }).then(() => {
            setTimeout(() => {
                getSelectedUserData();
            }, 500);
        }).catch((err) => {
            console.error(err);
            notifyError("Rol Grupları yüklenirken bir servis hatası meydana geldi.");
        })
    }

    async function getPermissionGroups() {
        await Axios.post(`${goRiceUrl}/api/employee/getPermissionGroupsWithRoles`, {}, getConfigToken).then((resp) => {
            if (resp.status === 200) {
                setPermissionGroupDatas(resp.data);
            } else {
                notifyError("Yetki Grupları yüklenirken bir hata meydana geldi.");
            }
        }).catch((err) => {
            console.error(err);
            notifyError("Yetki Grupları yüklenirken bir servis hatası meydana geldi.");
        })
    }

    async function getSelectedUserData() {
        await Axios.post(`${goRiceUrl}/api/employee/getRoles`, {
            employee_id: employeeId
        }, getConfigToken).then((resp) => {
            if (resp.status === 200) {
                if (resp.data.special_roles !== null) {

                    var arr = []
                    resp.data.special_roles.map(role => {
                        arr.push(role.role_id)

                    })
                    setSelectedRowKeys(arr)
                }
                if (resp.data.permissions !== null) {
                    const dataHolder = []
                    resp.data.permissions.map((item) => {
                        dataHolder.push(item.permission_group_id)
                    })
                    setSelectedPermissionGroup(dataHolder);
                }
                // document.getElementById("username_div").innerHTML = resp.data.full_name;
            } else {
                notifyError("Seçilen Kullanıcı verisi yüklenirken bir hata meydana geldi.");
            }
        })
            .catch((err) => {
                console.error(err);
                notifyError("Seçilen Kullanıcı verisi yüklenirken bir servis hatası meydana geldi.");
            })
    }

    async function getEmployeeById(employeeId) {
        await Axios.post(`${goRiceUrl}/api/employee/getByEmployeeID`, { employee_id: employeeId }, getConfigToken).then((resp) => {
            if (resp.status === 200) {
                const data = resp.data
                setSelectedRow(data);
            } else {
                notifyError("Çalışan verileri yüklenirken bir hata meydana geldi.");
            }
        }).then(() => {
            setTimeout(() => {
                getSelectedUserData();
            }, 500);
        }).catch((err) => {
            console.error(err);
            notifyError("Çalışan verileri yüklenirken bir servis hatası meydana geldi.");
        })
    }

    const validateObject = () => {
        var result = true
        if (document.getElementById("fullName").value === "") {
            result = false;
            notify("Ad Soyad bilgisi boş olamaz")
            return
        }
        if (document.getElementById("userName").value === "") {
            result = false;
            notify("Kullanıcı Adı bilgisi boş olamaz")
            return
        }
        if (document.getElementById("email").value === "") {
            result = false;
            notify("Email bilgisi boş olamaz")
            return
        }

        if (document.getElementById("password") !== "" && document.getElementById("password").className.includes("is-invalid")) {
            result = false;
            notify("Şifreniz belirtilen kurallara uymuyor")
            return
        }
        if (document.getElementById("password").value !== "" && document.getElementById("password").value !== document.getElementById("password2").value) {
            result = false;
            notify("Şifreler eşleşmiyor")
            return
        }

        if (document.getElementById("cinsiyet").childNodes[0].childNodes[0].value === "") {
            result = false;
            notify("Cinsiyet bilgisi boş olamaz")
            return
        }
        if (document.querySelector("#phone-number > div > input").className.includes("invalid")) {
            result = false;
            notify("Telefon numarası belirtilen kurallara uymuyor")
            return
        }

        let url = document.getElementById("url").value.trim(); // Boşlukları kırpar
        let currentUrl = window.location.origin; // Mevcut sitenin URL'si

        if (!url.startsWith(currentUrl) && url !== "") {
            result = false;
            notify(`URL ${currentUrl} ile başlamalı`);
            return;
        }
        return result;
    }

    function updateUserRole(id) {

        Axios.post(`${goRiceUrl}/api/employee/updateRoles`, {
            "employee_id": [id],
            "permission_group_ids": selectedPermissionGroup,
            "special_role_ids": selectedRowKeys,
            "user_id": parseInt(Buffer.from(localStorage.getItem("employee_id"), 'base64').toString('ascii'))
        }, getConfigToken).then((resp) => {
            notifySuccess("Kullanıcı kaydı başarıyla güncellendi.")
            setModalUpdate(false);
            setTrigger(!trigger)

        }).catch((err) => {
            console.error(err);
            notifyError("Kullanıcı güncellenirken bir servis hatası meydana geldi.");
        })
    }

    async function updateEmployee() {
        const checkboxHolder = []
        var arr = Array.from(document.getElementsByClassName("role_checkbox_new"));
        arr.filter(element => element.checked === true).map(checks => {
            checkboxHolder.push(parseInt(checks.id.split("_")[0]));
        })


        let url = document.getElementById("url").value

        if (validateObject()) {
            let phoneInput = document.querySelector("#phone-number > div > input").value

            const brandCols = document.getElementsByClassName("brandCol");
            const selectedBrands = [];
            for (let i = 0; i < brandCols.length; i++) {
                const brandCol = brandCols[i];
                const checkBox = brandCol.childNodes[0].childNodes[0];
                if (checkBox.value === 'true') {
                    selectedBrands.push(parseInt(brandCol.id.split("-")[1]));
                }
            }

            const taseronCols = document.getElementsByClassName("taseronCol");
            const selectedTaseron = [];
            for (let i = 0; i < taseronCols.length; i++) {
                const taseronCol = taseronCols[i];
                const checkBox = taseronCol.childNodes[0].childNodes[0];
                if (checkBox.value === 'true') {
                    selectedTaseron.push(parseInt(taseronCol.id.split("-")[1]));
                }
            }


            // "password": document.getElementById("password").value !== "" ? sha256(document.getElementById("password").value) : employeeDetail.Password,
            await Axios.post(`${goRiceUrl}/api/employee/updateEmployee`, {
                "cinsiyet": document.getElementById("cinsiyet").childNodes[0].childNodes[0].value,
                "email": document.getElementById("email").value,
                "employee_id": employeeId,
                "full_name": document.getElementById("fullName").value,
                "password": document.getElementById("password").value !== "" ? sha256(document.getElementById("password").value) : employeeDetail.password,
                "redirect_path": url.trim(),
                "user_id": parseInt(Buffer.from(localStorage.getItem("employee_id"), 'base64').toString('ascii')),
                "user_name": document.getElementById("email").value,
                "user_phone": ((phoneInput === "" || phoneInput === "+90") ? null : phoneInput)?.replaceAll(" ", ""),
                "brand_ids": selectedBrands,
                "subcontractor_ids": selectedTaseron,
                "warehouse_id": document.getElementById("depo").childNodes[0].childNodes[0].value !== "" ? parseInt(document.getElementById("depo").childNodes[0].childNodes[0].value) : null

            }, getConfigToken).then((resp) => {
                if (resp.status === 200) {
                    setTrigger(!trigger);
                    updateUserRole(employeeId);
                    setModalUpdate(false);
                    notifySuccess("Kullanıcı kaydı başarıyla güncellendi.");
                } else {
                    notifyError("Kullanıcı eklenirken bir hata meydana geldi.");
                }
            }).catch((err) => {
                console.error(err);
                notifyError("Kullanıcı eklenirken bir servis hatası meydana geldi.");
                setTimeout(() => {
                    document.getElementById("updateButtonNew").disabled = false
                }, 1500)
            })
        } else {
            setTimeout(() => {
                document.getElementById("updateButtonNew").disabled = false
            }, 1500)
        }
    }



    useEffect(() => {
        if (modalUpdate === true) {
            getRoleGroups();
            getPermissionGroups();
            getEmployeeById(employeeId);
            setCurrentActiveTab('1')
        }
    }, [modalUpdate])

    // Toggle active state for Tab
    const toggle = tab => {
        if (currentActiveTab !== tab) setCurrentActiveTab(tab);
    }

    return (
        <>
            <Modal size="lg" isOpen={modalUpdate} toggle={() => { setModalUpdate(!modalUpdate); }}>
                <ModalHeader toggle={() => { setModalUpdate(!modalUpdate); }}>
                    {t("Kullanıcı Güncelleme Formu")}
                </ModalHeader>
                <ModalBody>
                    <Nav tabs className='mb-2'>
                        <NavItem>
                            <NavLink
                                className={classnames({
                                    active:
                                        currentActiveTab === '1'
                                })}
                                onClick={() => { toggle('1'); }}
                            >
                                {t("Kullanıcı Bilgileri")}
                            </NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink
                                className={classnames({
                                    active:
                                        currentActiveTab === '2'
                                })}
                                onClick={() => { toggle('2'); }}
                            >
                                {t("Yetkilendirme")}
                            </NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink
                                className={classnames({
                                    active:
                                        currentActiveTab === '3'
                                })}
                                onClick={() => { toggle('3'); }}
                            >
                                {t("Diğer Yetkiler")}
                            </NavLink>
                        </NavItem>
                    </Nav>
                    <TabContent activeTab={currentActiveTab}>

                        <TabPane tabId="1">
                            <InformationForm employeeDetail={employeeDetail} toggle={toggle} isUpdate={true} setEmailChange={setEmailChange} />
                        </TabPane>
                        <TabPane tabId="2">
                            <PermissionTab selectedRowKeys={selectedRowKeys} setSelectedRowKeys={setSelectedRowKeys} roleGroups={roleGroups} permissionGroupDatas={permissionGroupDatas} selectedPermissionGroup={selectedPermissionGroup} setSelectedPermissionGroup={setSelectedPermissionGroup} toggle={toggle} isUpdateModal={true} isEmployeeUpdateModal={true} />
                        </TabPane>
                        <TabPane tabId="3">
                            <Taseron employeeDetail={employeeDetail} />
                            <hr />

                            <MarkaRoleYonetimi employeeDetail={employeeDetail} />
                        </TabPane>

                    </TabContent>

                </ModalBody>
                <ModalFooter>
                    <Col lg="12" className='d-flex justify-content-between align-items-center' >
                        <Button id='updateButtonNew' disabled={false} onClick={() => {
                            emailChange ? setControlModal(true) : updateEmployee(); document.getElementById("updateButtonNew").disabled = true
                        }} >{t("Kaydet")}</Button>
                        <Button id='cancelButtonNew' color='danger' onClick={() => { setModalUpdate(false) }} >{t("İptal")}</Button>
                    </Col>
                </ModalFooter>
            </Modal>
            <Modal size="lg" isOpen={controlModal}>
                <ModalBody>
                    <span>Kaydetme işleminden sonra Email adresiniz güncellenecektir. Onaylıyor musunuz ?</span>
                </ModalBody>
                <ModalFooter>
                    <Col lg="12" className='d-flex justify-content-between align-items-center' >
                        <Button id='saveButtonNew' disabled={false} onClick={() => { updateEmployee(); setControlModal(false) }} >Evet</Button>
                        <Button id='cancelButtonNew' color='danger' onClick={() => { setControlModal(false) }} >Hayır</Button>
                    </Col>
                </ModalFooter>
            </Modal>
        </>
    )
    /* eslint-disable */
}